import { Layers, TileLayer, VectorLayer } from "views/OLMap/Layers";
import { mapboxbase, googlebase } from "views/OLMap/Source";
import React, { useEffect, useState } from "react";
import "views/OLMap/ol-map.css";
import MapContext from "views/OLMap/Map/MapContext";
import PropTypes from "prop-types";
import { fromLonLat } from "ol/proj";
import * as ol from "ol";
import { defaults as defaultControls } from "ol/control/defaults";
import { useSelector } from "react-redux";
import { geojsons } from "assets/geojson";
import { MousePosition } from "ol/control";
import { createStringXY } from "ol/coordinate";
import { getFeaturesSourceFromJson } from "utils/mapProcess";
import { OSM, XYZ } from "ol/source";
import VectorSource from "ol/source/Vector";
import OLVectorLayer from "ol/layer/Vector";
import OLTileLayer from "ol/layer/Tile";
import { bingAerialLabels } from "../OLMap/Source";
import GridCard from "../Cards/GridCard";
import MKBox from "../../components/MKBox";
import vectorStyles from "../OLMap/vectorstyle";
import httpsUrlFromS3 from "../../utils/httpsUrlFromS3";

const GridCardMapComputingView = ({ map, mapRef, setMap, className, source }) => {
  const dataSelection = useSelector((state) => state.dataSelection);

  const viewOptions = {
    zoom: 4,
    center: fromLonLat([83, 28]),
    // extent: [6010000, 1600000, 12245143, 5160979],
  };

  const mousePositionControl = new MousePosition({
    coordinateFormat: createStringXY(4),
    projection: "EPSG:4326",
    className: "custom-mouse-position",
  });

  const [gridsLayer, setGridsLayer] = useState(null);
  const [tilesLayer, setTilesLayer] = useState(null);
  const [specialLayer, setSpecialLayer] = useState(null);
  const [xyzLayer, setxyzLayer] = useState(null);

  const [clicked, setClicked] = useState("");
  const [downloadClick, setDownloadClick] = useState(false);

  const gridNameLabelStyle = vectorStyles.GridNameLabel;
  const gridStatusLabelStyle = vectorStyles.GridStatusLabel;
  // const gridSubStatusLabelStyle = vectorStyles.GridSubStatusLabel;

  useEffect(() => {
    const initialGridsLayer = new OLVectorLayer({
      zIndex: 3,
      className: "grids",
      source: new VectorSource(),
      style(feature) {
        if (feature.get("status") === "Click Download") {
          const name = `${feature.get("id")}`;
          const status = feature.get("status");
          // const subStatus = feature.get("subStatus");
          gridNameLabelStyle.getText().setText(name);
          gridStatusLabelStyle.getText().setText(status);
          // gridSubStatusLabelStyle.getText().setText(subStatus);

          return [
            gridNameLabelStyle,
            vectorStyles.Grid,
            gridStatusLabelStyle,
            // gridSubStatusLabelStyle,
          ];
        }
        return [];
      },
      declutter: true,
    });

    const tileLabelStyle = vectorStyles.TileLabel;
    const tileDoneLabelStyle = vectorStyles.TileDoneLabel;

    const initialTilesLayer = new OLVectorLayer({
      zIndex: 2,
      className: "tiles",
      source: new VectorSource(),
      style(feature) {
        if (feature.get("gridStatus") === "Done") {
          return [];
        }
        if (feature.get("status") === "Done") {
          const label = `${feature.get("id")}\n${feature.get("status")}`;
          tileDoneLabelStyle.getText().setText(label);
          return [vectorStyles.TileDone, tileDoneLabelStyle];
        }

        const label = `${feature.get("id")}\n${feature.get("status")}`;
        tileLabelStyle.getText().setText(label);

        return [tileLabelStyle, vectorStyles.Tile];
      },
      declutter: true,
    });

    const initialSpecialBoundaryLayer = new OLVectorLayer({
      zIndex: 3,
      className: "special",
      source: new VectorSource(),
      style: [vectorStyles.Speical],
      declutter: true,
    });

    const initialxyzLayer = new OLTileLayer({
      zIndex: 1,
      source: new XYZ(),
      className: "mosaic_xyz",
    });

    const options = {
      view: new ol.View(viewOptions),
      layers: [initialGridsLayer, initialTilesLayer, initialxyzLayer, initialSpecialBoundaryLayer],
      controls: defaultControls().extend([mousePositionControl]),
      overlays: [],
    };
    const mapObject = new ol.Map(options);
    mapObject.setTarget(mapRef.current);
    setMap(mapObject);

    setxyzLayer(initialxyzLayer);
    setTilesLayer(initialTilesLayer);
    setGridsLayer(initialGridsLayer);
    setSpecialLayer(initialSpecialBoundaryLayer);

    return () => mapObject.setTarget(undefined);
  }, []);

  if (gridsLayer && source.gridSource) {
    gridsLayer.setSource(source.gridSource);
  }
  if (tilesLayer && source.tileSource) {
    tilesLayer.setSource(source.tileSource);
  }
  if (xyzLayer && source.xyzSource) {
    xyzLayer.setSource(source.xyzSource);
  }
  if (specialLayer && source.specialSource) {
    specialLayer.setSource(source.specialSource);
  }

  if (map !== null) {
    map.on("singleclick", (event) => {
      const clickeFeature = map.getFeaturesAtPixel(event.pixel, {
        layerFilter: (layer) => layer.getClassName() === "grids",
      });
      if (clickeFeature.length > 0 && clickeFeature[0].get("uri") !== null) {
        if (!downloadClick) {
          // todo 重复了7次
          setClicked(clickeFeature[0].get("uri"));
          setDownloadClick(true);
        }
      }
    });
  }

  useEffect(async () => {
    if (downloadClick) {
      try {
        const downloadUri = httpsUrlFromS3(clicked);
        window.open(downloadUri);
        setDownloadClick(false);
      } catch (error) {
        console.error("下载文件时出错：", error);
        setDownloadClick(false);
      }
    }
  }, [downloadClick]);

  const vectorlayer =
    dataSelection.buildin !== "" && !dataSelection.draw ? (
      <VectorLayer
        key={dataSelection.buildin}
        visible
        className={dataSelection.buildin}
        source={getFeaturesSourceFromJson(dataSelection.buildin, geojsons)}
        zIndex={1}
      />
    ) : null;

  const basemapStatus = useSelector((state) => state.dataLayers);
  const baseLayers = (
    <>
      {basemapStatus.filter((basemap) => basemap.name === "mapbox")[0].selected ? (
        <TileLayer source={mapboxbase()} className="mapbox" baseLayer zIndex={0} visible />
      ) : null}
      {basemapStatus.filter((basemap) => basemap.name === "google")[0].selected ? (
        <TileLayer source={googlebase()} className="google" baseLayer zIndex={0} visible />
      ) : null}
      {basemapStatus.filter((basemap) => basemap.name === "bing-Aerial-labels")[0].selected ? (
        <TileLayer
          source={bingAerialLabels()}
          className="bingAerialLables"
          baseLayer
          zIndex={0}
          visible
        />
      ) : null}{" "}
      {basemapStatus.filter((basemap) => basemap.name === "openStreetMap")[0].selected ? (
        <TileLayer source={new OSM()} className="osm" baseLayer zIndex={0} visible />
      ) : null}
    </>
  );

  return (
    <GridCard>
      <MKBox sx={{ p: 1 }}>
        <MapContext.Provider value={{ map }}>
          <div ref={mapRef} className={className}>
            <Layers>
              {baseLayers}
              {vectorlayer}
            </Layers>
          </div>
        </MapContext.Provider>
      </MKBox>
    </GridCard>
  );
};

GridCardMapComputingView.defaultProps = {
  map: null,
  setMap: null,
  mapRef: null,
  className: null,
  source: null,
};

GridCardMapComputingView.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
  setMap: PropTypes.oneOfType([PropTypes.any]),
  mapRef: PropTypes.oneOfType([PropTypes.any]),
  source: PropTypes.oneOfType([PropTypes.any]),
  className: PropTypes.string,
};

export default GridCardMapComputingView;
